import {
  Bot,
  Coins,
  Database,
  Link2,
  Repeat,
  ShieldCheck,
  type LucideIcon,
} from "lucide-react";

type BenefitIconName =
  | "Database"
  | "Repeat"
  | "Link2"
  | "Bot"
  | "Coins"
  | "ShieldCheck";

interface BenefitItem {
  id: string;
  title: string;
  description: string;
  iconName?: BenefitIconName;
}

interface BenefitsGridProps {
  items: BenefitItem[];
}

/**
 * BenefitsGrid
 *
 * 3-column benefit cards used by `benefits.items`-style sections. Identical
 * shape to ScopeGrid but with looser styling so it can carry a heading
 * inside the card and additional vertical breathing room. Useful for
 * "Migrationsziele", "Vorteile" and similar lists.
 */
export default function BenefitsGrid({ items }: BenefitsGridProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("BenefitsGrid: `items` array is empty or invalid.");
  }

  const iconMap: Record<BenefitIconName, LucideIcon> = {
    Database,
    Repeat,
    Link2,
    Bot,
    Coins,
    ShieldCheck,
  };

  return (
    <div className="benefits-grid">
      {items.map((item) => {
        const Icon = item.iconName ? iconMap[item.iconName] : null;
        if (item.iconName && !Icon) {
          throw new Error(`BenefitsGrid: unsupported iconName "${item.iconName}".`);
        }

        return (
          <article className="benefit" key={item.id}>
            {Icon ? (
              <span className="scope-ico" aria-hidden>
                <Icon size={20} strokeWidth={1.75} />
              </span>
            ) : null}
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </article>
        );
      })}
    </div>
  );
}
